export const getCompleteReturnPayload = (refundMethod, paymentMethodId) => {
  if (!refundMethod) return null

  const payload = {
    refund: {
      method: refundMethod,
    },
  }
  if (paymentMethodId) payload.refund.payment_method_id = paymentMethodId

  return payload
}
